import styled, { css } from 'styled-components';
import { Typography } from '../Typography/Typography';

export type PillStatusVariant = 'info';

const getStylesForVariant = (variant: PillStatusVariant) => {
  switch (variant) {
    case 'info':
      return {
        background: 'var(--teal-200)',
        color: 'var(--teal-800)',
      };
    default: {
      const _typecheck: never = variant;
      return null;
    }
  }
};

const StyledPillStatus = styled.div<{
  $variant: PillStatusVariant;
}>`
  height: 16px;
  padding: 4px 8px;
  border-radius: var(--border-radius-large);
  text-align: center;
  overflow: hidden;
  display: flex;
  align-items: center;
  justify-content: center;
  // transparent border so the shape is visible on windows high contrast mode,
  // which removes decorative styles like background color but makes all borders
  // 100% opacity black
  border: 1px solid rgba(0, 0, 0, 0);
  ${({ $variant }) => css`
    background: ${getStylesForVariant($variant)?.background};
    color: ${getStylesForVariant($variant)?.color};
  `}
  margin-bottom: 0;
  margin-top: 0;
  width: 180px;
`;

export type PillStatusProps = {
  children: React.ReactNode;
  className?: string;
  variant: PillStatusVariant;
};

/**
 * A pill-shaped status indicator for displaying time-sensitive information or status updates.
 */
export const PillStatus = ({ children, className, variant }: PillStatusProps) => {
  return (
    <StyledPillStatus className={className} $variant={variant}>
      <Typography styledAs="bodySmallDMSans" weight={600}>
        {children}
      </Typography>
    </StyledPillStatus>
  );
};

export default PillStatus;
